import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';

const Salaries = () => {
    const { isSidebarOpen } = useSidebar();

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [salaries, setSalaries] = useState([
        {
            employeeId: 'E001',
            employeeName: 'John Doe',
            salary: '₹1,00,000',
            daysPresent: 22,
            daysAbsent: 2,
            weekOff: 4,
            publicHoliday: 1,
            paidLeave: 1,
            leave: 2
        },
        {
            employeeId: 'E002',
            employeeName: 'Jane Smith',
            salary: '₹1,50,000',
            daysPresent: 20,
            daysAbsent: 3,
            weekOff: 4,
            publicHoliday: 2,
            paidLeave: 2,
            leave: 1
        },
        {
            employeeId: 'E003',
            employeeName: 'Alice Brown',
            salary: '₹90,000',
            daysPresent: 21,
            daysAbsent: 1,
            weekOff: 4,
            publicHoliday: 1,
            paidLeave: 1,
            leave: 3
        },
    ]);

    const [filteredSalaries, setFilteredSalaries] = useState(salaries);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Effect to handle filtering
    useEffect(() => {
        const filtered = salaries.filter((salary) =>
            Object.values(salary).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredSalaries(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, salaries]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredSalaries.length / itemsPerPage);
    const currentData = filteredSalaries.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Handlers for Edit and Delete actions
    const handleEdit = (index) => {
        // Logic for editing the salary details
        console.log(`Editing salary details at index ${index}`);
    };

    const handleDelete = (index) => {
        const updatedSalaries = salaries.filter((_, i) => i !== index);
        setSalaries(updatedSalaries);
    };

    return (
        <>
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Salary</h1>

                    <button className="oms-add-btn">
                        Help
                    </button>
                </div>


                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                <div className="salary-info-p">
                    The data for March will be updated on April 11th.
                </div>

                <div className="customer-table salary-table">
                    <table>
                        <thead>
                            <tr>
                                <th>View</th>
                                <th>ID & Name</th>
                                <th>Salary</th>
                                <th>No. of Days Present</th>
                                <th>No. of Days Absent</th>
                                <th>Week Off</th>
                                <th>Public Holiday</th>
                                <th>Paid Leave</th>
                                <th>Leave</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredSalaries.length > 0 ? (
                                filteredSalaries.map((salary, index) => (
                                    <tr key={index}>
                                        <td>
                                            <Link to='/salary-detail'>
                                                <button className="view-button">
                                                    <i className="fa-solid fa-eye"></i>
                                                </button>
                                            </Link>
                                        </td>
                                        <td>
                                            <strong>{salary.employeeId}</strong> - {salary.employeeName}
                                        </td>
                                        <td>{salary.salary}</td>
                                        <td>{salary.daysPresent}</td>
                                        <td>{salary.daysAbsent}</td>
                                        <td>{salary.weekOff}</td>
                                        <td>{salary.publicHoliday}</td>
                                        <td>{salary.paidLeave}</td>
                                        <td>{salary.leave}</td>
                                        <td>
                                            <button className="edit-button">
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(index)}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" style={{ textAlign: 'center' }}>
                                        No salary records found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>
        </>
    );
};

export default Salaries;
